import loadable from '@loadable/component';
import loadableModule from '../../components/loadable-module';

const LinkPilesModule = loadableModule({
    LoadableComponent: loadable(() =>
        import(
            /* webpackChunkName: "linkpiles" */
            './'
        )
    ),
    componentName: 'LinkPiles',
    placeholder: {
        placeholderType: 'TitledBlock',
        size: 'md',
    },
});
export default LinkPilesModule;
